module.exports = __webpack_public_path__ + "static/duodecim-f619d5005f006e8e7d8e9efbcbf5cb7d.svg";